import React, { Component } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { formatSar } from "./format";
import "./dashboard.scss";

const radialOptions = (color) => ({
  chart: {
    sparkline: {
      enabled: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: [color],
  stroke: {
    lineCap: "round",
  },
  plotOptions: {
    radialBar: {
      hollow: {
        margin: 0,
        size: "70%",
      },
      track: {
        margin: 0,
      },
      dataLabels: {
        show: false,
      },
    },
  },
});

class EarningReports extends Component {
  state = {
    menu: false,
  };

  render() {
    const weekly = this.props.earnings?.weekly || { amount: 0, percent: 0 };
    const monthly = this.props.earnings?.monthly || { amount: 0, percent: 0 };

    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <Dropdown
              className="float-end"
              isOpen={this.state.menu}
              toggle={() => this.setState({ menu: !this.state.menu })}
            >
              <DropdownToggle tag="i" className="arrow-none card-drop">
                <i className="mdi mdi-dots-vertical"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem href="">Sales Report</DropdownItem>
                <DropdownItem href="">Export Report</DropdownItem>
                <DropdownItem href="">Profit</DropdownItem>
                <DropdownItem href="">Action</DropdownItem>
              </DropdownMenu>
            </Dropdown>

            <h4 className="card-title mb-4">Earning Reports</h4>
            <div className="text-center">
              <Row>
                <Col sm={6}>
                  <div>
                    <div className="mb-3">
                      <div id="radialchart-1" className="apex-charts">
                        <ReactApexChart
                          options={radialOptions("#5664d2")}
                          series={[weekly.percent]}
                          type="radialBar"
                          height="60"
                        />
                      </div>
                    </div>

                    <p className="text-muted text-truncate mb-2">
                      Weekly Earnings
                    </p>
                    <h5 className="mb-0">{formatSar(weekly.amount)}</h5>
                  </div>
                </Col>

                <Col sm={6}>
                  <div className="mt-5 mt-sm-0">
                    <div className="mb-3">
                      <div id="radialchart-2" className="apex-charts">
                        <ReactApexChart
                          options={radialOptions("#1cbb8c")}
                          series={[monthly.percent]}
                          type="radialBar"
                          height="60"
                        />
                      </div>
                    </div>

                    <p className="text-muted text-truncate mb-2">
                      Monthly Earnings
                    </p>
                    <h5 className="mb-0">{formatSar(monthly.amount)}</h5>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default EarningReports;
